import { React, useState, useEffect, useRef } from 'react'
import DatePicker from 'react-datepicker';
import { format, parse } from 'date-fns';
import { faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel, faFilePdf, faTrashCan, faFile } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { APIConstants, FilesAPIConstants, PatientTrackerConstants } from '../utilities/Constants';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Provider, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import EncounterTrackerTable from '../components/EncounterTrackerTable';
import HorizontalBarChart from '../components/HorizontalBarChart';
import BarChart from '../components/BarChart';
import PatLineChart from '../components/PatLineChart';
import PieChart from '../components/PieChart';
import Draggable from 'react-draggable';
import DonutChart from '../components/DonutChart';

const ProviderTracker = () => {


    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(false);
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);

    const [showDataModal, setShowDataModal] = useState(false);
    const [showEncModal, setShowEncModal] = useState(false);
    const [showAuditModal, setShowAuditModal] = useState(false);

    const [hasFetched, setHasFetched] = useState(false);

    const [activeRow, setActiveRow] = useState(null);
    const [unitactiveRow, setUnitActiveRow] = useState(null);
    const [counselorData, setCounselorData] = useState([]);
    const [providerData, setProviderData] = useState([]);
    const [encounterData, setEncounterData] = useState([]);
    const [CptTrackerData, setCptTrackerData] = useState([]);
    const [CptTrackerTable2, setCptTrackerTable2] = useState([]);
    const [unitTrackerTable1, setUnitTrackerTable1] = useState([]);
    const [unitTrackerTable2, setUnitTrackerTable2] = useState([]);
    const [selectedProviders, setSelectedProviders] = useState([]);
    const [showEncounterPatient, setShowEncounterPatient] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchByProviderName, setSearchByProviderName] = useState("");
    const [searchByAllProviderName, setSearchByAllProviderName] = useState("");

    const [searchQueryTable1, setSearchQueryTable1] = useState("");
    const [searchQueryTable2, setSearchQueryTable2] = useState("");
    const [searchQueryTable3, setSearchQueryTable3] = useState("");
    const [chartType, setChartType] = useState("horizontalBar");
    const [sortConfigTable2, setSortConfigTable2] = useState({ key: null, ascending: true });
    const [sortConfigTable3, setSortConfigTable3] = useState({ key: null, ascending: true });
    const [userAuditData, setUserAuditData] = useState([]);
    const [searchByAuditDescription, setSearchByAuditDescription] = useState("");
    const [searchByEncProvider, setSearchByEncProvider] = useState("");
    const [searchByEncPatientName, setSearchByEncPatientName] = useState("");
    const [searchByAudit1Provider, setSearchByAudit1Provider] = useState("");
    const [visibleCounts, setVisibleCounts] = useState({
        totalEncounters: true,
        SignedEnc: true,
        UnsignedEnc: true,
        nonduplicatePatcount: "Total Patient",
        CPTCount: true,
        UnitCount: true,
    });

    const userData = useSelector((state) => state.user.user);
    console.log('userData:', userData);




    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;


    const sAuthToken = useSelector((state) => state.user.user.sAuthToken);



    const formatDate = (date) => {
        return date.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        });
    };



    useEffect(() => {
        document.title = "Patient Tracker";

        const today = new Date();

        // Get the first day of the current month
        const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // Get the first day of the previous month
        const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

        // Get the last day of the previous month
        const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);


        setStartDate(formatDate(firstDayOfLastMonth));
        setEndDate(formatDate(lastDayOfLastMonth));

    }, []);









    const handleTable1SearchChange = (event) => {
        setSearchQueryTable1(event.target.value);
    };

    const handleTable2SearchChange = (event) => {
        setSearchQueryTable2(event.target.value);
    };

    const handleTable3SearchChange = (event) => {
        setSearchQueryTable3(event.target.value);
    };


    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };



    const filteredTable1 = encounterData.filter(item =>
        (item.ProviderName?.toLowerCase().includes(searchQuery.toLowerCase()) || searchQuery === "") &&
        (item.ProviderName?.toLowerCase().includes(searchQueryTable1.toLowerCase()) || searchQueryTable1 === "")
    );

    const filteredTable2 = CptTrackerData.filter(item =>
        (item.ProviderName?.toLowerCase().includes(searchQuery.toLowerCase()) || searchQuery === "") &&
        (item.ProviderName?.toLowerCase().includes(searchQueryTable2.toLowerCase()) || searchQueryTable2 === "")
    );

    const filteredTable3 = unitTrackerTable1.filter(item =>
        (item.ProviderName?.toLowerCase().includes(searchQuery.toLowerCase()) || searchQuery === "") &&
        (item.ProviderName?.toLowerCase().includes(searchQueryTable3.toLowerCase()) || searchQueryTable3 === "")
    );





    const filteredAuditData = userAuditData?.filter((item) =>
        item.AuditDescription?.toLowerCase().includes(searchByAuditDescription.toLowerCase())
    );



    const filteredEncData = showEncounterPatient.filter((item) =>
        item.ProviderName?.toLowerCase().includes(searchByEncProvider.toLowerCase()) &&
        (`${item.FirstName} ${item.LastName}`.toLowerCase().includes(searchByEncPatientName.toLowerCase()))
    );


    const filteredEncPatData = showEncounterPatient.filter((item) =>

        `${item.FirstName} ${item.LastName}`.toLowerCase().includes(searchByEncPatientName.toLowerCase())
    );




    const providers = filteredTable1.map((item) => item.ProviderName || "-");
    const totalEncounters = filteredTable1.map((item) => Number(item.totalEncounters) || 0);
    const signedEncounters = filteredTable1.map((item) => Number(item.SignedEnc) || 0);
    const unsignedEncounters = filteredTable1.map((item) => Number(item.UnsignedEnc) || 0);
    const nonduplicatePatcount = filteredTable1.map((item) => Number(item.nonduplicatePatcount) || 0);
    const CPTCount = filteredTable1.map((item) => Number(item.CPTCount) || 0);
    const UnitCount = filteredTable1.map((item) => Number(item.UnitCount) || 0);




    const handleSort = (table, key) => {
        if (table === "table2") {
            setSortConfigTable2((prev) => ({
                key,
                ascending: prev.key === key ? !prev.ascending : true,
            }));
        } else if (table === "table3") {
            setSortConfigTable3((prev) => ({
                key,
                ascending: prev.key === key ? !prev.ascending : true,
            }));
        }
    };




    const sortedTable2 = [...filteredTable2].sort((a, b) => {
        if (!sortConfigTable2.key) return 0;
        const valA = Number(a[sortConfigTable2.key]) || 0;
        const valB = Number(b[sortConfigTable2.key]) || 0;
        return sortConfigTable2.ascending ? valA - valB : valB - valA;
    });

    const sortedTable3 = [...filteredTable3].sort((a, b) => {
        if (!sortConfigTable3.key) return 0;
        const valA = Number(a[sortConfigTable3.key]) || 0;
        const valB = Number(b[sortConfigTable3.key]) || 0;
        return sortConfigTable3.ascending ? valA - valB : valB - valA;
    });






    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);

            console.log("Selected start date:", formattedDate);
            setEndDate(date);
            setIsStartOpen(false)
        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected End date:", formattedDate);
            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };






    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);
            setEndDate(today);
            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );









    const chunkedProviders = [];
    for (let i = 0; i < providerData.length; i += 3) {
        chunkedProviders.push(providerData.slice(i, i + 3));
    }



    const getProvider = () => {


        var jsonOBJ = {
            PracticeID: userPracticeID,
            SearchByRole: 1
        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url =
            APIConstants.COMMON_BASE_URL +
            `CommonData/GetPracticeProviders?sJSONInput=${sInputJSON}`;
        console.log("URL", url);

        const response = fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${sAuthToken}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {

                // const parsedData = data.objProviderGroups[0].objProviderList;

                console.log("Providers>>>>>>", data);
                setProviderData(Array.isArray(data) ? data : []);

            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    };




    const providerIds = providerData?.length > 0 ? providerData.map(provider => provider.ProviderID) : [];

    useEffect(() => {
        if (
            !hasFetched &&
            startDate &&
            endDate &&
            selectedProviders.length > 0 &&
            providerData?.length > 0 &&
            chunkedProviders?.length > 0
        ) {
            handleGetProviderData();
            handleGetRoleBasedCPTTrackerData();
            handleGetRoleBasedCPTUnitsData();
            getProvider();
            setHasFetched(true);
        }
    }, [startDate, endDate, hasFetched, selectedProviders, providerData, chunkedProviders]);






    useEffect(() => {
        getProvider();
        setLoading(true);
        setTimeout(() => {
            handleAllTrackerDetails();

            setLoading(false);
        }, 500);

        console.log("Providers>>>>>>", providerData, providerIds);
    }, []);




    const handleGetProviderData = async () => {
        console.log("Providers>>>>>>", providerData, providerIds);

        var jsonOBJ = {
            sFromDate: startDate,
            sToDate: endDate,
            lsProviders: selectedProviders


        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetProviderEncounterTrackerData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)

                setEncounterData(parsedData)

                console.log("Response of" + PatientTrackerConstants.GetProviderEncounterTrackerData, parsedData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }






    const handleGetRoleBasedCPTTrackerData = async () => {


        var jsonOBJ = {
            sFromDate: startDate,
            sToDate: endDate,
            lsProviders: selectedProviders,
            sRoleID: userData.roleID,
            sPracticeID: userPracticeID


        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetRoleBasedCPTTrackerData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)
                setCptTrackerData(parsedData.Table1)
                setCptTrackerTable2(parsedData.Table2)
                console.log("Response of" + PatientTrackerConstants.GetRoleBasedCPTTrackerData, parsedData, CptTrackerData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }







    const handleGetRoleBasedCPTUnitsData = async () => {


        var jsonOBJ = {
            sFromDate: startDate,
            sToDate: endDate,
            lsProviders: selectedProviders,
            sRoleID: userData.roleID,
            sPracticeID: userPracticeID


        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetRoleBasedCPTUnitsData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)
                setUnitTrackerTable1(parsedData.Table1)
                setUnitTrackerTable2(parsedData.Table2)
                console.log("Response of" + PatientTrackerConstants.GetRoleBasedCPTUnitsData, parsedData, unitTrackerTable1);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    const handleAllTrackerDetails = () => {
        setLoading(true);
        setTimeout(() => {
            handleGetProviderData();
            handleGetRoleBasedCPTTrackerData();
            handleGetRoleBasedCPTUnitsData();
            setLoading(false);
        }, 500);



    }







    const handleGetPatientTrackerDetailedData = async (item, countType) => {


        var jsonOBJ = {

            sProviderID: item.ProviderID,
            sRoleID: item.UserRole,
            sFromDate: startDate,
            sToDate: endDate,
            sSignedIndicator: countType,
            sIsSupervisor: item.isSuperVisor,
            sPracticeID: userPracticeID,


        }

        var sInputJSON = JSON.stringify(jsonOBJ);


        const url = `${APIConstants.BASE_URL_BILLING}${PatientTrackerConstants.GetPatientTrackerDetailedData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data)
                setShowEncounterPatient(parsedData)

                if (countType === 2) {
                    setShowDataModal(true)
                }

                else {
                    setShowEncModal(true)
                }
                console.log("Response of" + PatientTrackerConstants.GetPatientTrackerDetailedData, parsedData);




            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }






    const handleGetUserAudits = (item) => {

        console.log("Data", item);


        const InputJSON = {

            PracticeID: userPracticeID,
            DataID: 0,
            Module: 'Provider_Encounter',
            SubModule: '',
            sFromDate: startDate,
            sToDate: endDate,
            PatientID: item.PatientID ?? "",
            UserID: item.ProviderUserID ?? item.UserID ?? ""
        };


        const sInputJSON = JSON.stringify(InputJSON);

        console.log("Input of " + PatientTrackerConstants.GetUserAudits, sInputJSON);

        const url = `${APIConstants.BASE_AUDIT_URL}${PatientTrackerConstants.GetUserAudits}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                console.log('API response:' + PatientTrackerConstants.GetUserAudits, parsedData);
                setShowAuditModal(true)
                setUserAuditData(parsedData)

            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };






    const handleGetEncounterAudits = (item) => {

        console.log("Data", item);


        const InputJSON = {

            PracticeID: userPracticeID,
            DataID: 0,
            Module: 'Provider_Encounter',
            SubModule: '',
            sFromDate: item.DOSString,
            sToDate: item.DOSString,
            PatientID: item.PatientID ?? "",
            UserID: ""
        };


        const sInputJSON = JSON.stringify(InputJSON);

        console.log("Input of " + PatientTrackerConstants.GetUserAudits, sInputJSON);

        const url = `${APIConstants.BASE_AUDIT_URL}${PatientTrackerConstants.GetUserAudits}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {

                const parsedData = JSON.parse(data)
                console.log('API response:' + PatientTrackerConstants.GetUserAudits, parsedData);
                setShowAuditModal(true)
                setUserAuditData(parsedData)

            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };






    const handleRowClick = (index) => {
        setActiveRow(index);
    };

    const handleUnitRowClick = (index) => {
        setUnitActiveRow(index);
    };






    const formatDOSDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };



    const handleCloseModals = () => {
        // Close all modals

        setShowDataModal(false)
        setShowEncModal(false);


    };


    const handleAuditCloseModals = () => {

        setShowAuditModal(false);

    }


    useEffect(() => {
        if (selectedProviders.length === 0) {

            const allProviderIDs = chunkedProviders.flat().map(provider => provider.ProviderID);
            setSelectedProviders(allProviderIDs);
        }
    }, [chunkedProviders]);



    const handleCheckboxChange = (providerID) => {
        setSelectedProviders(prevSelected =>
            prevSelected.includes(providerID)
                ? prevSelected.filter(id => id !== providerID)
                : [...prevSelected, providerID]
        );
    };


    const columns = [
        { header: "#", accessor: "index" },
        { header: "Name", accessor: "ProviderName" },
        { header: "Total Patients", accessor: "nonduplicatePatcount" },
        { header: "Signed Encounters", accessor: "SignedEnc" },
        { header: "Unsigned Encounters", accessor: "UnsignedEnc" },
        { header: "Total Encounters", accessor: "totalEncounters" },
        { header: "Total CPTs", accessor: "CPTCount" },
        { header: "Total Units", accessor: "UnitCount" }
    ];






    const getSignedOffMsg = (EncounterStatus, AssistantSignoff) => {
        if (EncounterStatus === "True" && AssistantSignoff === "1") {
            return "Both";
        } else if (EncounterStatus === "True" && AssistantSignoff === "0") {
            return "Supervisor";
        } else if (EncounterStatus === "False" && AssistantSignoff === "1") {
            return "Non Supervisor";
        } else {
            return "None";
        }
    };





    const uniqueServices = [...new Set(CptTrackerTable2.map(item => item.ServiceName))];


    const groupedCPTs = uniqueServices.map(service => ({
        service,
        cpts: CptTrackerTable2.filter(item => item.ServiceName === service).map(item => item.CPT)
    }));




    const cptCodes = groupedCPTs.flatMap((group) => group.cpts);




    //Filtered Units Tracker Data

    const unitServices = [...new Set(unitTrackerTable2.map(item => item.ServiceName))];


    const groupedunits = unitServices.map(service => ({
        service,
        cpts: unitTrackerTable2.filter(item => item.ServiceName === service).map(item => item.CPT)
    }));



    const unitCodes = groupedunits.flatMap((group) => group.cpts);



    const handlePatLinkClick = (item) => {
        const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

        console.log("PatientID>>>", item.PatientID);
        localStorage.setItem("PatientID", item.PatientID);

        window.open(url, '_blank');
    };




    const printRef = useRef();



    const handleGraphPrint = (chartTitle) => {
        const printWindow = window.open("", "_blank");
        const chartContent = printRef.current.innerHTML;
    
        printWindow.document.writeln(`
          <html>
            <head>
              <title>Encounter Data Overview </title>
              <style>
                @media print {
                  body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                    margin: 0;
                    padding: 10px;
                    font-family: Arial, sans-serif;
                  }
                  #chart-title {
                    text-align: center;
                    font-size: 2rem;
                    font-weight: bolder;
                    color: black;
                    margin-bottom: 20px;
                    text-transform:uppercase;
                  }
                  #bar {
                    text-align: center;
                  }
                   .apexcharts-menu, .apexcharts-toolbar, .apexcharts-xcrosshairs, .apexcharts-ycrosshairs {
                    display: none !important;
                  }
                }
              </style>
            </head>
            <body>
              <div id="chart-title">${chartTitle}Chart</div>
              <div id='bar'>
                ${chartContent}
              </div>
              <script>
                window.onload = function () {
                  window.print();
                  window.close();
                }
              </script>
            </body>
          </html>
        `);
        printWindow.document.close();
    };
    




    const handlePrint = (tableId) => {
        const printElement = document.getElementById(tableId);

        if (!printElement) {
            console.error(`Element with ID '${tableId}' not found.`);
            return;
        }

        const printContent = printElement.innerHTML;

        const printWindow = window.open("", "_blank");

        if (printWindow) {
            printWindow.document.writeln(`
                <html>
                <head>
                    <title>Patient Tracker</title>
                    <style>
                        @media print {
                            body {
                                margin: 0;
                                padding: 10px;
                                font-family: Arial, sans-serif;
                                zoom: 0.8; 
                                color:#000305 !important;
                                font-size: 28px; 
                            }

                             .print-title {
                                font-size: 2rem;
                                font-weight: bolder;
                                margin-bottom: 20px;
                               
                            }
                            
                            table {
                                width: auto !important;
                                border-collapse: collapse;
                                table-layout: fixed;
                                word-wrap: break-word;
                               
                            }
                            th, td {
                                border: 2px solid black !important;
                                padding: 12px;
                                text-align: center;
                                word-wrap: break-word;
                                color: black !important; 
                                font-size: 18px; 
                                font-weight: bolder;
                            }
                            th {
                                background-color: #0173b7;
                                font-weight: bolder;
                            }
                            td {
                                background-color: #f8f9fa;
                                font-weight: bolder;
                            }
                            td:last-child, th:last-child {
                                white-space: normal !important;
                                overflow: visible !important;
                            }
                            .patient-table {
                                page-break-inside: avoid;
                                max-height: 100vh;
                                border: 2px solid black !important;
                            }
                            @page {
                                size: A4 landscape;
                                margin: 10mm;
                            }
                            .pdf-icon {
                                width: 20px;
                                height: 20px;
                            }
                        }
                    </style>
                </head>
                <body>

                 <div class="print-title">${tableId} 
                
                  <label>${formattedStartDate} - ${formattedEndDate}</label>
                 </div> 
                    ${printContent}
                    <script>
                        window.onload = function() {
                        window.print();
                    };
                    window.onafterprint = function() {
                        window.close();
                    };
                 
                    window.addEventListener('focus', function () {
                        window.close();
                    });

                       
                    </script>
                </body>
                </html>
            `);
            printWindow.document.close();
        } else {
            console.error("Failed to open print window.");
        }
    };










    const encounterTableRef = useRef(null);
    const sortedTable2Ref = useRef(null);
    const sortedTable3Ref = useRef(null);

    const patientTableRef = useRef(null);



    const exportEncToExcel = (tableId, pageName) => {
        let table;

        if (tableId === "encounterTable") {
            table = encounterTableRef.current;
        } else if (tableId === "cptTrackerTable") {
            table = sortedTable2Ref.current;
        } else if (tableId === "unitTrackerTable") {
            table = sortedTable3Ref.current;
        }
        else if (tableId === "patientTracker") {
            table = patientTableRef.current;
        }

        if (!table) {
            console.error(`Table with ID '${tableId}' not found.`);
            return;
        }

        let sPrintableData = table.innerHTML;
        if (!sPrintableData) {
            console.error("No table data found.");
            return;
        }

        console.log(`Exporting ${pageName} Table HTML:`, sPrintableData);


        const requestData = {
            PrintableData: sPrintableData,
            PageName: pageName,
        };


        const InputJSONLevelOne = JSON.stringify(requestData);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        console.error("Export to Excel failed:", errorData);
                        throw new Error(`Server responded with status ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('API response:', data);
                if (data && data[2]) {
                    window.open(data[2], '_blank');
                } else {
                    console.error("Invalid API response format.");
                }
            })
            .catch(error => {
                console.error('Export to Excel failed', error);
            });
    };







    const exportToExcel = (tableId, pageName) => {
        let table, tableData;

        if (tableId === "encounterTable") {
            table = encounterTableRef.current;
            tableData = encounterData;
        } else if (tableId === "cptTrackerTable") {
            table = sortedTable2Ref.current;
            tableData = sortedTable2;
        } else if (tableId === "unitTrackerTable") {
            table = sortedTable3Ref.current;
            tableData = sortedTable3;
        }

        if (!table || !tableData) {
            console.error(`Table with ID '${tableId}' not found or has no data.`);
            return;
        }

        let sPrintableData = "<table border='1'>";

        // Table Head
        sPrintableData += "<thead><tr>";
        sPrintableData += "<th>#</th>";
        sPrintableData += "<th>Name</th>";

        groupedCPTs.forEach(group => {
            group.cpts.forEach(cpt => {
                sPrintableData += `<th>${cpt}</th>`;
            });
        });


        sPrintableData += "<th>Total</th></tr></thead>";


        sPrintableData += "<tbody>";
        tableData.forEach((item, index) => {
            let rowTotal = cptCodes.reduce((sum, cpt) => sum + (Number(item[cpt]) || 0), 0);

            sPrintableData += `<tr>`;
            sPrintableData += `<td>${index + 1}</td>`;
            sPrintableData += `<td>${item.ProviderName}</td>`;

            cptCodes.forEach(cpt => {
                sPrintableData += `<td>${item[cpt] ? item[cpt] : "0"}</td>`;
            });



            sPrintableData += `<td>${rowTotal}</td>`;
            sPrintableData += `</tr>`;
        });
        sPrintableData += "</tbody>";


        sPrintableData += "<tfoot><tr>";


        sPrintableData += `<td colspan="2"><strong>Total</strong></td>`;
        sPrintableData += `<td colspan="2"></td>`;


        cptCodes.forEach(cpt => {
            let totalCPTValue = tableData.reduce((sum, row) => sum + (Number(row[cpt]) || 0), 0);
            sPrintableData += `<td>${totalCPTValue}</td>`;
        });





        let grandTotal = tableData.reduce(
            (totalSum, row) => totalSum + cptCodes.reduce((rowSum, cpt) => rowSum + (Number(row[cpt]) || 0), 0),
            0
        );

        sPrintableData += `<td>${grandTotal}</td>`;
        sPrintableData += "</tr></tfoot>";

        sPrintableData += "</table>";

        console.log(`Exporting ${pageName} Table HTML:`, sPrintableData);

        const requestData = {
            PrintableData: sPrintableData,
            PageName: pageName,
        };

        const InputJSON = JSON.stringify(JSON.stringify(requestData));

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: InputJSON,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        console.error("Export to Excel failed:", errorData);
                        throw new Error(`Server responded with status ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log("API response:", data);
                if (data && data[2]) {
                    window.open(data[2], "_blank");
                } else {
                    console.error("Invalid API response format.");
                }
            })
            .catch(error => {
                console.error("Export to Excel failed", error);
            });
    };











    const exportToPDF = (tableId, pageName) => {
        let table;

        if (tableId === "encounterTable") {
            table = encounterTableRef.current;
        } else if (tableId === "cptTrackerTable") {
            table = sortedTable2Ref.current;
        } else if (tableId === "unitTrackerTable") {
            table = sortedTable3Ref.current;
        }
        else if (tableId === "patientTracker") {
            table = patientTableRef.current;
        }

        if (!table) {
            console.error(`Table with ID '${tableId}' not found.`);
            return;
        }

        let sPrintableData = table.innerHTML;
        if (!sPrintableData) {
            console.error("No table data found.");
            return;
        }

        console.log(`Exporting ${pageName} Table HTML:`, sPrintableData);


        const tableWithStyles = `
            <style>
               body { font-family: Arial, sans-serif; margin: 20px; }
                h1 { text-align: center; font-size: 20px; margin-bottom: 20px; text-transform:camelcase; justify-content: space-between; }
                table { border-collapse: collapse; width: 100%; }
                th, td { border: 1px solid black; padding: 5px; text-align: left; }
                th { background-color: #f2f2f2; }
            </style>
            <h1>${pageName}</h1>
            <h1>${formattedStartDate} - ${formattedEndDate}</h1>
            ${sPrintableData}
        `;

        const requestData = {
            PrintableData: tableWithStyles,
            PageName: pageName,
        };

        const InputJSONLevelOne = JSON.stringify(requestData);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        console.error("Export to PDF failed:", errorData);
                        throw new Error(`Server responded with status ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log('API response:', data);
                if (data && data[2]) {
                    window.open(data[2], '_blank');
                } else {
                    console.error("Invalid API response format.");
                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };




    const filterData = (key) => {
        if (!visibleCounts[key]) return [];

        return filteredTable1.map((item) => {
            if (key === "totalEncounters") {
                return (Number(item.SignedEnc) || 0) + (Number(item.UnsignedEnc) || 0);
            }
            return Number(item[key]) || 0;
        });
    };



    const labels = {
        totalEncounters: "Total Encounters",
        SignedEnc: "Signed",
        UnsignedEnc: "Unsigned",
        nonduplicatePatcount: "Total Patients",
        CPTCount: "Total CPTs",
        UnitCount: "Total Units"
    };


    const handleCheckboxCountsChange = (countType) => {
        setVisibleCounts(prevState => ({
            ...prevState,
            [countType]: !prevState[countType]
        }));
    };







    const count = Math.max(...filteredTable1.map(o => (Number(o.CPTCount))), 0)
    const UnitCounts = Math.max(...filteredTable1.map(o => (Number(o.UnitCount))), 0);
    const Totalpat = Math.max(...filteredTable1.map(o => (Number(o.nonduplicatePatcount))), 0);
    const TotalEnc = Math.max(...filteredTable1.map(o => (Number(o.UnsignedEnc) + Number(o.SignedEnc))), 0);
    const maxvalue = Math.max(count, UnitCounts, Totalpat, TotalEnc)


    const RoundValue = () => {

        if (maxvalue % 10 === 0) {
            return maxvalue
        }
        else {

            const fractionVal = maxvalue % 10;
            const nonFractionVal = maxvalue - fractionVal

            return nonFractionVal + 10;
        }

    }



    const chartData = {
        providers,
        totalEncounters: filterData("totalEncounters"),
        signedEncounters: filterData("SignedEnc"),
        unsignedEncounters: filterData("UnsignedEnc"),
        nonduplicatePatcount: filterData("nonduplicatePatcount"),
        CPTCount: filterData("CPTCount"),
        UnitCount: filterData("UnitCount"),
        maxvalue: RoundValue()
    };



    const formattedStartDate = new Date(startDate).toLocaleDateString('en-US');
    const formattedEndDate = new Date(endDate).toLocaleDateString('en-US');




    return (
        <>

            <div className='patient-container mt-2'>



                <div style={{ width: "auto", height: 'auto', marginTop: "10px", marginLeft: "10px", backgroundColor: '#cff4fc' }}>
                    <table className="table table-bordered table-info"
                        style={{ width: "auto", borderCollapse: "collapse", tableLayout: "fixed" }}>
                        <tbody>
                            {chunkedProviders.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((provider) => (
                                        <td key={provider.ProviderID}
                                            style={{ padding: "10px", margin: "0", whiteSpace: "nowrap", maxWidth: "1500px", overflow: "hidden" }}>
                                            <label style={{ display: "inline-flex", alignItems: "center", gap: '10px', fontSize: '1.1rem' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedProviders.includes(provider.ProviderID)}
                                                    onChange={() => handleCheckboxChange(provider.ProviderID)}
                                                    style={{ margin: 0, padding: 0 }}
                                                />
                                                {provider.ProviderName}
                                            </label>
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>




                <div className='d-flex mt-5'>
                    <div className="datepicker-container" style={{ marginLeft: '10px', zIndex: 10 }}>
                        <label onClick={getProvider}>From:</label>
                        <DatePicker
                            selected={startDate ? new Date(startDate) : null}
                            onChange={handleStartDateChange}
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={100}

                            className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                            placeholderText="MM/dd/yyyy"

                            calendarContainer={CalendarStartContainer}
                            open={isStartOpen}
                            onFocus={() => setIsStartOpen(true)}
                            onInputClick={() => setIsStartOpen(true)}
                            onClickOutside={() => setIsStartOpen(false)}
                            renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                const selectedMonth = selectedDate.getMonth();
                                const selectedYear = selectedDate.getFullYear();

                                return (
                                    <div>
                                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                            {"<"}
                                        </button>
                                        <select
                                            value={selectedMonth}
                                            onChange={({ target: { value } }) => changeMonth(Number(value))}
                                        >
                                            {getMonths(selectedYear)}
                                        </select>
                                        <select
                                            value={selectedYear}
                                            onChange={({ target: { value } }) => changeYear(Number(value))}
                                        >
                                            {Array.from({ length: 100 }, (v, k) => (
                                                <option key={k} value={new Date().getFullYear() - k}>
                                                    {new Date().getFullYear() - k}
                                                </option>
                                            ))}
                                        </select>
                                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                            {">"}
                                        </button>
                                    </div>
                                );
                            }}
                        />
                    </div>

                    <div className="datepicker-container" style={{ marginLeft: '20px', zIndex: 10 }}>
                        <label>To:</label>
                        <DatePicker
                            selected={endDate ? new Date(endDate) : null}
                            onChange={handleEndDateChange}
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={100}
                            className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                            placeholderText="MM/dd/yyyy"
                            popperPlacement="bottom-start"

                            calendarContainer={CalendarContainer}
                            open={isEndOpen}
                            onFocus={() => setIsEndOpen(true)}
                            onInputClick={() => setIsEndOpen(true)}
                            onClickOutside={() => setIsEndOpen(false)}
                            renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                const selectedMonth = selectedDate.getMonth();
                                const selectedYear = selectedDate.getFullYear();

                                return (
                                    <div>
                                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                            {"<"}
                                        </button>
                                        <select
                                            value={selectedMonth}
                                            onChange={({ target: { value } }) => changeMonth(Number(value))}
                                        >
                                            {getMonths(selectedYear)}
                                        </select>
                                        <select
                                            value={selectedYear}
                                            onChange={({ target: { value } }) => changeYear(Number(value))}
                                        >
                                            {Array.from({ length: 100 }, (v, k) => (
                                                <option key={k} value={new Date().getFullYear() - k}>
                                                    {new Date().getFullYear() - k}
                                                </option>
                                            ))}
                                        </select>
                                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                            {">"}
                                        </button>
                                    </div>
                                );
                            }}
                        />
                    </div>



                    <div className='searchicon-container' style={{ marginLeft: '10px', marginTop: '0px', height: '30px' }}>
                        <FontAwesomeIcon style={{ marginLeft: '7px', cursor:'pointer' }} icon={faMagnifyingGlass} onClick={handleAllTrackerDetails} />
                    </div>

                </div>




                {loading && (
                    <div className="overlay">
                        <div className="spinner-container">
                            <div className="spinner-grow text-danger" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                )}



                <div style={{ marginLeft: '10px', marginTop: '20px' }}>
                    <label>Search Provider:</label>
                    <input type='text'
                        placeholder='Search'
                        style={{ width: '140px', borderRadius: '5px', border: '1px solid black', marginLeft: '5px' }}
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                </div>


                <div className='encounter-title mt-4 d-flex justify-content-between align-items-center' >
                    <label style={{ fontSize: '1.2rem', marginTop: '5px', textAlign: 'center', fontWeight: 'bold' }}> Encounter Tracker</label>

                    <div className='icon-container' style={{ marginLeft: '10px' }}>
                        <FontAwesomeIcon style={{cursor:'pointer'}} onClick={() => handlePrint("Encounter Tracker Table")} icon={faPrint} />
                        <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', cursor:'pointer' }} onClick={() => exportEncToExcel("encounterTable", "EncounterTable")} icon={faFileExcel} />
                        <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', cursor:'pointer' }} onClick={() => exportToPDF("encounterTable", "Encounter Table")} icon={faFilePdf} />


                    </div>

                </div>

                <div id="Encounter Tracker Table" ref={encounterTableRef} className='patient-table mt-1'>


                    <EncounterTrackerTable columns={columns} data={filteredTable1}
                        searchQuery={searchQueryTable1}
                        handleGetPatientTrackerDetailedData={handleGetPatientTrackerDetailedData}
                        handleGetUserAudits={handleGetUserAudits}

                    />

                </div>






                <div className='cpt-title d-flex justify-content-between align-items-center'>
                    <label style={{ fontSize: '1.2rem', marginTop: '5px', textAlign: 'center', fontWeight: 'bold' }}> CPT Tracker</label>

                    <div className='icon-container'>
                        <FontAwesomeIcon style={{ float: 'right', cursor:'pointer' }} onClick={() => handlePrint("CptTracker Table")} icon={faPrint} />
                        <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', cursor:'pointer' }} onClick={() => exportToExcel("cptTrackerTable", "cptTrackerTable")} icon={faFileExcel} />
                        <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', cursor:'pointer' }} onClick={() => exportToPDF("cptTrackerTable", "Cpt Tracker Table")} icon={faFilePdf} />


                    </div>

                </div>

                <div id="CptTracker Table" ref={sortedTable2Ref} className='patient-table mt-1'>


                    <table className="table table-hover  table-bordered border border-white responsive mt-1" style={{ marginLeft: "1px" }}>
                        <thead>

                            <tr >
                                <th className="col-sm col-th text-white" style={{ backgroundColor: "#0173b7" }}>#</th>
                                <th className="col col-th text-white" style={{ backgroundColor: "#0173b7" }}>
                                    Name
                                    <br />
                                    <input type="text" placeholder="Search" style={{ width: "120px", borderRadius: "5px" }} value={searchQueryTable2} onChange={handleTable2SearchChange} />
                                </th>
                                {groupedCPTs.map((group, index) => (
                                    <th key={index} className="col col-th text-white align-top" style={{ backgroundColor: "#0173b7", textAlign: 'center' }} colSpan={group.cpts.length}>
                                        {group.service}
                                    </th>
                                ))}

                                <th className="col col-th text-white align-top" style={{ backgroundColor: "lightpink" }}>Total</th>
                            </tr>


                            <tr>
                                <th className="col-sm col-th text-white" style={{ backgroundColor: "#0173b7" }}></th>
                                <th className="col col-th text-white" style={{ backgroundColor: "#0173b7" }}></th>
                                {Array.from(new Set(groupedCPTs.flatMap((group) => group.cpts))).map((cpt, index) => (
                                    <th key={index} className="col col-th text-white align-top" style={{ backgroundColor: "#0173b7", textAlign: 'center' }}>
                                        <Link style={{ whiteSpace: "nowrap", color: "white" }} onClick={() => handleSort("table2", cpt)}>
                                            {cpt}
                                        </Link>
                                    </th>
                                ))}
                                <th className="col col-th text-white" style={{ backgroundColor: "lightpink" }}></th>
                            </tr>
                        </thead>

                        <tbody>


                            {sortedTable2.map((item, index) => {

                                const rowTotal = cptCodes.reduce((sum, cpt) => sum + (Number(item[cpt]) || 0), 0);

                                return (
                                    <tr
                                        className={`${activeRow === index ? "table-warning" : ""} table-primary`}
                                        key={index}
                                        onClick={() => handleRowClick(index)}
                                    >
                                        <td>{index + 1}</td>
                                        <td>{item.ProviderName}</td>
                                        {cptCodes.map((cpt, idx) => (
                                            <td key={idx}>
                                                <label style={{ whiteSpace: "nowrap", color: "black" }}>
                                                    {item[cpt] ? item[cpt] : "0"}
                                                </label>
                                            </td>
                                        ))}

                                        <td style={{ fontWeight: "bold", backgroundColor: "lightpink" }}>{rowTotal}</td>

                                    </tr>
                                );
                            })}
                        </tbody>

                        <tfoot>
                            <tr className="table-secondary">
                                <td style={{ fontWeight: "bold" }}>Total</td>
                                <td>-</td>

                                {cptCodes.map((cpt, idx) => (
                                    <td key={idx} style={{ fontWeight: "bold" }}>
                                        {CptTrackerData.reduce((sum, row) => sum + (Number(row[cpt]) || 0), 0)}
                                    </td>
                                ))}



                                <td style={{ fontWeight: "bold", backgroundColor: "lightgray" }}>
                                    {CptTrackerData.reduce((totalSum, row) =>
                                        totalSum + cptCodes.reduce((rowSum, cpt) => rowSum + (Number(row[cpt]) || 0), 0)
                                        , 0)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>




                </div>




                <div className='units-title d-flex justify-content-between align-items-center'>
                    <label style={{ fontSize: '1.2rem', marginTop: '5px', textAlign: 'center', fontWeight: 'bold' }}> Units Tracker</label>

                    <div className='icon-container'>
                        <FontAwesomeIcon style={{ float: 'right', cursor:'pointer' }} onClick={() => handlePrint("UnitTracker Table")} icon={faPrint} />
                        <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', cursor:'pointer' }} onClick={() => exportToExcel("unitTrackerTable", "unitTrackerTable")} icon={faFileExcel} />
                        <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', cursor:'pointer' }} onClick={() => exportToPDF("unitTrackerTable", "Unit Tracker Table")} icon={faFilePdf} />


                    </div>
                </div>







                <div id="UnitTracker Table" ref={sortedTable3Ref} className='patient-table mt-1'>


                    <table className="table table-hover table-bordered border border-white responsive mt-1" style={{ marginLeft: "1px" }}>
                        <thead>

                            <tr >
                                <th className="col-sm col-th text-white" style={{ backgroundColor: "#0173b7" }}>#</th>
                                <th className="col col-th text-white" style={{ backgroundColor: "#0173b7" }}>
                                    Name
                                    <br />
                                    <input type="text" placeholder="Search" style={{ width: "120px", borderRadius: "5px" }} value={searchQueryTable3}
                                        onChange={handleTable3SearchChange} />
                                </th>
                                {groupedunits.map((group, index) => (
                                    <th key={index} className="col col-th text-white align-top" style={{ backgroundColor: "#0173b7", textAlign: 'center' }} colSpan={group.cpts.length}>
                                        {group.service}
                                    </th>
                                ))}

                                <th className="col col-th text-white align-top" style={{ backgroundColor: "#d7d469" }}>Total</th>
                            </tr>


                            <tr>
                                <th className="col-sm col-th text-white" style={{ backgroundColor: "#0173b7" }}></th>
                                <th className="col col-th text-white" style={{ backgroundColor: "#0173b7" }}></th>

                                {Array.from(new Set(groupedunits.flatMap((group) => group.cpts))).map((cpt, index) => (
                                    <th key={index} className="col col-th text-white align-top" style={{ backgroundColor: "#0173b7", textAlign: 'center' }}>
                                        <Link style={{ whiteSpace: "nowrap", color: "white" }} onClick={() => handleSort("table3", cpt)}>
                                            {cpt}
                                        </Link>
                                    </th>
                                ))}


                                <th className="col col-th text-white align-top" style={{ backgroundColor: "#d7d469" }}></th>
                            </tr>
                        </thead>

                        <tbody>
                            {sortedTable3.map((item, index) => {
                                const rowUnitTotal = unitCodes.reduce((sum, cpt) => sum + (Number(item[cpt]) || 0), 0);

                                return (
                                    <tr
                                        className={`${unitactiveRow === index ? "table-warning" : ""} table-primary`}
                                        key={index}
                                        onClick={() => handleUnitRowClick(index)}
                                    >
                                        <td>{index + 1}</td>
                                        <td>{item.ProviderName}</td>
                                        {unitCodes.map((cpt, idx) => (
                                            <td key={idx}>
                                                <label style={{ whiteSpace: "nowrap", color: "black" }}>
                                                    {item[cpt] ? item[cpt] : "0"}
                                                </label>
                                            </td>
                                        ))}

                                        <td style={{ fontWeight: "bold", backgroundColor: '#d7d469' }}>{rowUnitTotal}</td>
                                    </tr>
                                );
                            })}
                        </tbody>

                        <tfoot>
                            <tr className="table-secondary">
                                <td style={{ fontWeight: "bold" }}>Total</td>
                                <td>-</td>
                                {unitCodes.map((cpt, idx) => (
                                    <td key={idx} style={{ fontWeight: "bold" }}>
                                        {unitTrackerTable1.reduce((sum, row) => sum + (Number(row[cpt]) || 0), 0)}
                                    </td>
                                ))}


                                <td style={{ fontWeight: "bold", backgroundColor: "lightgray" }}>
                                    {unitTrackerTable1.reduce((totalSum, row) =>
                                        totalSum + unitCodes.reduce((rowSum, cpt) => rowSum + (Number(row[cpt]) || 0), 0)
                                        , 0)}
                                </td>


                            </tr>
                        </tfoot>



                        {showDataModal && (
                            <>



                                <Draggable>

                                    <div className='patdialog-box' >
                                        <FontAwesomeIcon style={{
                                            width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black',
                                            float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white'
                                        }} onClick={handleCloseModals} icon={faXmark} />

                                        <div className='d-flex' style={{ float: 'right', fontSize: '1.5rem' }}>
                                            <FontAwesomeIcon style={{ float: 'right', backgroundColor: '#DDF0FB', cursor: 'pointer' }} onClick={() => handlePrint("patientTracker")} icon={faPrint} />
                                            <FontAwesomeIcon style={{ color: 'green', backgroundColor: '#DDF0FB', cursor: 'pointer' }} onClick={() => exportEncToExcel("patientTracker", "patientTracker")} icon={faFileExcel} />
                                            <FontAwesomeIcon style={{ color: 'red', backgroundColor: '#DDF0FB', cursor: 'pointer' }} onClick={() => exportToPDF("patientTracker", "patientTracker")} icon={faFilePdf} />


                                        </div>




                                        <div className=' mt-2' id='patientTracker' ref={patientTableRef}>
                                            <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{ marginLeft: '5px', width: 'auto' }}>

                                                <thead>

                                                    <tr className='align-top' >

                                                        <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>


                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '380px' }}>Patient Name
                                                            <br />
                                                            <input type='text'
                                                                placeholder='Search'
                                                                style={{ width: '120px', borderRadius: '5px' }}
                                                                value={searchByEncPatientName}
                                                                onChange={(e) => setSearchByEncPatientName(e.target.value)}


                                                            />
                                                        </th>




                                                    </tr>


                                                </thead>

                                                <tbody>

                                                    {filteredEncPatData.map((item, index) => (

                                                        <tr className={`${activeRow === index ? 'table-warning' : ''} ${'table-primary'}`}

                                                            key={index}
                                                            onClick={() => handleRowClick(index)}>
                                                            <td>{index + 1}</td>

                                                            <td>  <label className='linkspan' onClick={() => handlePatLinkClick(item)}>
                                                                {item.LastName},{item.FirstName}
                                                            </label>


                                                                <div style={{ float: 'right' }}>
                                                                    <span> <FontAwesomeIcon style={{ marginLeft: '20px', color: '#000', fontWeight: '100' }} onClick={() => handleGetEncounterAudits(item)} icon={faFile} /></span>
                                                                </div>
                                                            </td>



                                                        </tr>
                                                    ))}


                                                </tbody>



                                            </table>



                                        </div>
                                    </div>
                                </Draggable>
                            </>

                        )}






                        {showEncModal && (
                            <>



                                <Draggable>

                                    <div className='patdialog-box'>
                                        <FontAwesomeIcon style={{
                                            width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black',
                                            float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white'
                                        }} onClick={handleCloseModals} icon={faXmark} />

                                        <div className='d-flex' style={{ float: 'right', fontSize: '1.5rem' }}>
                                            <FontAwesomeIcon style={{ float: 'right', backgroundColor: '#DDF0FB', cursor: 'pointer' }} onClick={() => handlePrint("patientTracker")} icon={faPrint} />
                                            <FontAwesomeIcon style={{ color: 'green', backgroundColor: '#DDF0FB', cursor: 'pointer' }} onClick={() => exportEncToExcel("patientTracker", "patientTracker")} icon={faFileExcel} />
                                            <FontAwesomeIcon style={{ color: 'red', backgroundColor: '#DDF0FB', cursor: 'pointer' }} onClick={() => exportToPDF("patientTracker", "patientTracker")} icon={faFilePdf} />


                                        </div>




                                        <div className=' mt-2' id='patientTracker' ref={patientTableRef}>
                                            <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{ marginLeft: '5px', width: 'auto' }}>

                                                <thead>

                                                    <tr className='align-top' >

                                                        <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>

                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>DOS

                                                        </th>


                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Patient Name
                                                            <br />
                                                            <input type='text'
                                                                placeholder='Search'
                                                                style={{ width: '120px', borderRadius: '5px' }}
                                                                value={searchByEncPatientName}
                                                                onChange={(e) => setSearchByEncPatientName(e.target.value)}

                                                            />
                                                        </th>

                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Provider
                                                            <br />
                                                            <input type='text'
                                                                placeholder='Search'
                                                                style={{ width: '120px', borderRadius: '5px' }}
                                                                value={searchByEncProvider}
                                                                onChange={(e) => setSearchByEncProvider(e.target.value)}

                                                            />

                                                        </th>

                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Supervisor

                                                        </th>

                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                                            <label style={{ width: '120px' }}>Signed Off By</label>

                                                        </th>


                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Form

                                                        </th>


                                                    </tr>


                                                </thead>

                                                <tbody>

                                                    {filteredEncData.map((item, index) => (

                                                        <tr className={`${activeRow === index ? 'table-warning' : ''} ${'table-primary'}`}

                                                            key={index}
                                                            onClick={() => handleRowClick(index)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.DOSString}</td>
                                                            <td>

                                                                <label className='linkspan' onClick={() => handlePatLinkClick(item)}>
                                                                    {item.LastName},{item.FirstName}
                                                                </label>

                                                                <div style={{ float: 'right' }}>
                                                                    <span> <FontAwesomeIcon style={{ marginLeft: '20px', color: '#000', fontWeight: '100' }} onClick={() => handleGetEncounterAudits(item)} icon={faFile} /></span>
                                                                </div>
                                                            </td>
                                                            <td>{item.ProviderName}</td>
                                                            <td>
                                                                <label style={{ width: '100px' }}>{item.SupProviderName}</label>
                                                            </td>
                                                            <td> <span className="label">{getSignedOffMsg(item.EncounterStatus, item.AssistantSignoff)}</span></td>
                                                            <td>
                                                                <label style={{ width: '100px' }}>{item.FormName}</label>
                                                            </td>


                                                        </tr>
                                                    ))}


                                                </tbody>



                                            </table>



                                        </div>
                                    </div>
                                </Draggable>
                            </>

                        )}






                        {showAuditModal && (
                            <>



                                <Draggable>

                                    <div className='patdialog-box' style={{ height: '500px', width: '400px', marginTop: '100px', marginLeft: '150px' }}>
                                        <FontAwesomeIcon style={{
                                            width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black',
                                            float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white'
                                        }} onClick={handleAuditCloseModals} icon={faXmark} />




                                        <div className=' mt-2 '>
                                            <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{ marginLeft: '5px', width: 'auto' }}>

                                                <thead>

                                                    <tr className='align-top' >

                                                        <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>


                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '380px' }}>Description
                                                            <br />
                                                            <input
                                                                type="text"
                                                                placeholder="Search"
                                                                value={searchByAuditDescription}
                                                                onChange={(e) => setSearchByAuditDescription(e.target.value)}
                                                                style={{ width: "120px", borderRadius: "5px" }}
                                                            />

                                                        </th>

                                                        <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '380px' }}>Date

                                                        </th>




                                                    </tr>


                                                </thead>

                                                <tbody>

                                                    {filteredAuditData?.map((item, index) => (

                                                        <tr className={`${activeRow === index ? 'table-warning' : ''} ${'table-success'}`}

                                                            key={index}
                                                            onClick={() => handleRowClick(index)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.AuditDescription}



                                                            </td>
                                                            <td>{formatDOSDate(item.AuditDate)}</td>


                                                        </tr>
                                                    ))}


                                                </tbody>



                                            </table>



                                        </div>
                                    </div>
                                </Draggable>
                            </>

                        )}



                    </table>




                </div>








                <div style={{ marginBottom: "20px", display: 'flex', marginTop: '50px', marginLeft: '10px' }}>
                    {Object.keys(visibleCounts).map((count) => (
                        <div key={count} style={{ marginLeft: '10px' }}>
                            <input
                                type="checkbox"
                                checked={visibleCounts[count]}
                                onChange={() => handleCheckboxCountsChange(count)}
                            />
                            <label style={{ marginLeft: "2px", fontSize: '1.1rem' }}>{labels[count]}</label>
                        </div>
                    ))}
                </div>



                <div style={{ marginTop: "30px", textAlign: "center" }}>
                    <label><b>Select Chart Type: </b></label>
                    <select
                        onChange={(e) => setChartType(e.target.value)}
                        value={chartType}
                        style={{ padding: "5px", marginLeft: "10px", border: '1px solid black' }}
                    >
                        <option value="bar">Column Bar</option>
                        <option value="horizontalBar">Horizontal Bar</option>
                        <option value="line">Line </option>
                        <option value="pie">Pie chart </option>
                        <option value="donut">Donut chart </option>
                    </select>

                    <FontAwesomeIcon style={{ marginLeft: '10px', fontSize: '1.5rem' }} onClick={() => handleGraphPrint( chartType)} icon={faPrint} />
                </div>


                <div id='bar' ref={printRef} style={{ marginTop: "50px", textAlign: "center", fontSize: '1.1rem', color: 'gray', fontWeight: 'bold' }}>
                    <label>
                        Showing Data of Signed, Unsigned, Total Encounters, Total Patients for {formattedStartDate} - {formattedEndDate}
                    </label>






                    <div >

                        {chartType === "horizontalBar" && (
                            <HorizontalBarChart
                                {...chartData}
                            />
                        )}


                        {chartType === "bar" && (

                            <BarChart
                                {...chartData}
                            />

                        )}


                        {chartType === "line" && (

                            <PatLineChart
                                {...chartData}
                            />

                        )}




                        {chartType === "pie" && (

                            <PieChart
                                {...chartData}
                            />

                        )}



                        {chartType === "donut" && (

                            <DonutChart
                                {...chartData}
                            />

                        )}
                    </div>




                </div>


            </div>







        </>
    )
}

export default ProviderTracker